import React, {
  useState,
  useEffect,
  useMemo,
  useRef,
  createContext,
  useContext,
  useReducer,
} from 'react';
import { Dialog, Select, Input } from '@tencent/spaui';
import get from 'lodash/get';
import { RPCFactory } from '../../../utils/RequestUtil';
import { beaconInstance } from '../../../instrumentation/beaconSetup';
import { isLeadsRole } from '../../../utils/routes';

const ctx = createContext('leads batch distribute');
const { Provider } = ctx;

const ACTION = {
  SET_METHOD: 'SET_METHOD',
  SET_LEADS: 'SET_LEADS',
  UPDATE_EMPLOYEES: 'UPDATE_EMPLOYEES',
  UPDATE_PERCENT: 'UPDATE_PERCENT',
  CHECK_LAST: 'CHECK_LAST',
  INIT: 'INIT',
};

const METHOD_OPTIONS = [
  {
    label: '平均',
    value: 'average',
  },
  {
    label: '自定义',
    value: 'custom',
  },
];

export const getDistributeMap = (arr, n) => {
  let rest = n;
  const map = {};
  const list = arr.map((item, index) => {
    const percent = item.percent * n / 100;
    const integer = Math.floor(percent);
    map[item.id] = integer;
    rest -= integer;
    return {
      ...item,
      index,
      num: percent - integer,
    };
  });
  const sort = () => {
    const sorter = (curr, next) => {
      if (curr.num === next.num) {
        return next.index - curr.index;
      }
      return curr.num - next.num;
    }
    return [...list].sort(sorter);
  };

  const sorted = sort();
  const totalPercent = Math.round(list.map((item) => item.percent)
    .reduce((p, c) => p + c, 0));

  // 猴子
  if (totalPercent === 100) {
    while (rest-- > 0) {
      const curr = sorted.pop();
      curr && map[curr.id]++;
    }
  } else {
    sorted.map((item) => {
      if (item.num < 0.5) return;
      if (rest < 0) return;
      map[item.id]++;
      rest--;
    });
  }
  return map;
};

export const AverageBody = () => {
  const { state } = useContext(ctx);
  const { employees } = state;

  return (
    <div className="mld-body">
      <div className="mld-count">
        <span>已设置客服&nbsp;</span>
        <span className="color-orange">{ employees.length }人</span>
      </div>
      <div className="mld-average-users">
        {
          employees.map((item) => (
            <div className="mld-au-item" key={item.id}>
              { item.name }
            </div>
          ))
        }
      </div>
    </div>
  );
};

export const ColorPercent = ({ value }) => {
  if (0 <= value && value < 100) return (
    <span className="mld-percent">
      <span className="color-gray">已设置&nbsp;</span>
      <span className="color-orange">{ value }%</span>
      <span>，请调整至100%</span>
    </span>
  );

  if (value === 100) return (
    <span className="mld-percent">
      <span className="color-gray">已设置&nbsp;</span>
      <span className="color-green">100%</span>
    </span>
  );

  return (
    <span className="mld-percent">
      <span className="color-red">已设置 { value }%</span>
      <span>，请调整至100%</span>
    </span>
  );
};

export const PercentEditor = (props) => {
  const { state, dispatch } = useContext(ctx);
  const { data } = props;
  const { countMap } = state;
  const ref = useRef(null);

  const handlePercentChange = (e, value) => {
    if (value && !/^\d+$/) return;
    if (parseInt(value) > 100) return;
    dispatch({
      type: ACTION.UPDATE_PERCENT,
      payload: {
        percent: parseFloat(value),
        item: data,
      },
    });
  };

  const handleCheckLast = () => {
    dispatch({ type: ACTION.CHECK_LAST });
  };

  const handleFocus = () => {
    const dom = ref.current.querySelector('input');
    dom && dom.select();
  };

  return (
    <div className="mld-percenter" ref={ref}>
      <span className="mld-percenter-name color-gray" title={data.name}>
        { data.name }
      </span>
      <Input
        type="number"
        value={data.percent}
        onChange={handlePercentChange}
        onBlur={handleCheckLast}
        onFocus={handleFocus}
      />
      <div className="percent-symbol">%</div>
      <span>{ countMap[data.id] || 0 }条</span>
    </div>
  );
};

export const CustomBody = () => {
  const { state } = useContext(ctx);
  const { employees } = state;

  const totalPercent = employees.map((item) => item.percent || 0)
    .reduce((prev, curr) => prev + curr, 0);

  return (
    <div className="mld-body">
      <div className="mld-count">
        <span>设置客服接收量&nbsp;</span>
        <ColorPercent value={totalPercent} />
      </div>
      <div className="mld-custom-users">
        {
          employees.map((item) => (
            <PercentEditor
              key={item.id}
              data={item}
            />
          ))
        }
      </div>
    </div>
  );
};

const Distribute = (props) => {
  const { leads } = props;
  const { state, dispatch } = useContext(ctx);
  const [loading, setLoading] = useState(false);
  const { method, employees } = state;

  const employeeList = useMemo(() => {
    console.log('==== list ====', props.ownerList)
    if (!Array.isArray(props.ownerList)) return [];
    return props.ownerList.filter((item) => item.active)
      .map((item) => {
        let { label } = item;
        label = label.split(' - ')[0];
        return { ...item, label };
      });
  }, [props.ownerList]);

  const canSubmit = useMemo(() => {
    if (method === 'average') return true;
    const percent = employees.map((item) => item.percent)
      .reduce((p, c) => p + c, 0);
    return percent === 100;
  }, [method, employees]);

  const handleMethodChange = (e, value) => {
    dispatch({
      type: ACTION.SET_METHOD,
      payload: value,
    });
  };

  const handleEmployeeChange = (e, values, map) => {
    const fresh = values.map((id) => ({
      id,
      name: map[id].label,
      percent: 0,
      isLast: false,
      isEdited: false,
    }));

    dispatch({
      type: ACTION.UPDATE_EMPLOYEES,
      payload: fresh,
    });
  };

  const handleSubmit = () => {
    let users = employees;
    let map = state.countMap;
    if (method === 'average') {
      users = users.map((item) => ({ ...item, percent: 100 / users.length }));
      map = getDistributeMap(users, leads.length);
    }
    if (method === 'custom') {
      const percent = users.map((item) => item.percent)
        .reduce((p, c) => p + c, 0);
      if (percent !== 100) {
        alert('请检查百分比设置');
        return;
      }
    }
    beaconInstance.onUserAction(
      'btn_click',
      { page: '线索批量分配', name: method },
    );
    setLoading(true);
    try {
      props.onSubmit({ method, leads, map, employees: users })
        .finally(() => setLoading(false));
    } catch(e) {}
  };

  useEffect(() => {
    dispatch({
      type: ACTION.SET_LEADS,
      payload: leads,
    });
  }, [leads, dispatch]);

  useEffect(() => {
    if (employeeList.length < 1) return;

    // 获取配置的权限和线索分配的权限一致
    const canDistribute = isLeadsRole('管理员', '超级管理员', '广告优化师', '数据分析人员', '客服经理');
    if (!canDistribute) return;

    const params = {};
    if (props.tab === 'group') {
      params.userGroupId = window.pageProps.userGroupId;
    }
    RPCFactory.leadsManage.getBatchDistributeConfig(params)
      .done((data) => {
        const employeeMap = employeeList.reduce((prev, curr) => {
          prev[curr.value] = curr;
          return prev;
        }, {});
        const method = data.distributeType === 2 ? 'custom' : 'average';
        let employees = (data.distributeItems || [])
          .filter((item) => item.targetOwnerIdDistributeStatus === 0);
        employees = employees.map((item) => {
          return {
            id: item.targetOwnerId,
            name: get(employeeMap, [item.targetOwnerId, 'label']),
            isEdited: true,
            percent: item.proportion || 0,
          };
        });
        dispatch({
          type: ACTION.INIT,
          payload: {
            method,
            employees,
          },
        });
      })
      .fail(console.warn);
  }, [employeeList, dispatch, props.tab]);

  const ids = state.employees.map((item) => item.id);

  let body = null;
  if (method === 'average') {
    body = (<AverageBody />);
  } else if (method === 'custom') {
    body = (<CustomBody />);
  }

  return (
    <Dialog
      show={props.show}
      type="normal"
      title="设置线索归属方案"
      style={{ width: 600 }}
      className="modal-leads-distribute"
      onSubmit={handleSubmit}
      onCancel={props.onCancel}
      onClose={props.onCancel}
      loading={loading}
      disabled={!canSubmit}
    >
      <div className="mld-method">
        <span>将所选的&nbsp;</span>
        <span className='color-orange'>{ leads.length }条</span>
        <span>&nbsp;线索</span>
        <Select
          placeholder="请选择"
          data={METHOD_OPTIONS}
          value={method}
          onChange={handleMethodChange}
          style={{ width: 96, margin: '0 12px' }}
        />
        <span>分配给以下客服</span>
      </div>
      <Select
        multiple
        clear={true}
        placeholder="请选择客服"
        data={employeeList}
        value={ids}
        onChange={handleEmployeeChange}
        style={{ marginTop: 16 }}
      />
      { body }
    </Dialog>
  );
};

const initState = {
  method: 'average',
  leads: [],
  employees: [],
  countMap: {},
};

const reducer = (state = initState, action) => {
  const { type, payload } = action;
  switch (type) {
    case ACTION.INIT:
      return { ...state, ...payload };
    case ACTION.SET_METHOD:
      return { ...state, method: payload };
    case ACTION.SET_LEADS: {
      const countMap = getDistributeMap(state.employees, payload.length);
      return { ...state, leads: payload, countMap };
    }
    case ACTION.UPDATE_EMPLOYEES: {
      const oldEmployeeMap = state.employees.reduce((prev, curr) => {
        prev[curr.id] = curr;
        return prev;
      }, {});
      const employees = payload.map((item) => {
        const { id } = item;
        if (oldEmployeeMap[id]) return oldEmployeeMap[id];
        return item;
      });
      return { ...state, employees };
    }
    case ACTION.UPDATE_PERCENT: {
      const employees = state.employees.map((employee) => {
        if (employee !== payload.item) return employee;
        return {
          ...payload.item,
          isEdited: true,
          percent: payload.percent,
        };
      });
      return { ...state, employees };
    }
    case ACTION.CHECK_LAST: {
      const unedited = state.employees.filter((item) => !item.isEdited);
      if (unedited.length !== 1) {
        const countMap = getDistributeMap(state.employees, state.leads.length);
        const employees = state.employees.map((item) => {
          const percent = item.percent || 0;
          return { ...item, percent };
        });
        return { ...state, employees, countMap };
      };
      const percentCount = state.employees.map((item) => item.percent)
        .reduce((p, c) => p + c, 0);
      const employees = state.employees.map((_item) => {
        const item = { ..._item, percent: _item.percent || 0 };
        if (item.isEdited) return item;
        return {
          ...item,
          isEdited: true,
          percent: Math.max(0, 100 - percentCount),
        };
      });
      const countMap = getDistributeMap(employees, state.leads.length);
      return { ...state, employees, countMap };
    }
    default:
      return state;
  }
};

export default (props) => {
  const [state, dispatch] = useReducer(reducer, initState);

  return (
    <Provider value={{ state, dispatch }}>
      <Distribute {...props} />
    </Provider>
  );
};
